import { render } from "./LegacyEventSaveButton.vue?vue&type=template&id=bad06f98"
import script from "./LegacyEventSaveButton.vue?vue&type=script&lang=js"
export * from "./LegacyEventSaveButton.vue?vue&type=script&lang=js"
script.render = render

export default script